import { projectsProjectDetailHostCapability, projectsProjectDetailHostSlots, } from '@crest/module-projects/contracts/detail-host';
import { defineProjectsProjectDetailLauncher } from '@crest/module-projects/contracts/detail-launcher';
import { assetsSettingRegistrations } from '../settings/assets-setting-definitions.js';
import { assetsModuleManifest } from '../assets.module.js';
export const assetsWebModuleContribution = {
    moduleId: 'assets',
    manifest: assetsModuleManifest,
    settingRegistrations: assetsSettingRegistrations,
    settingEditors: [],
    hostContracts: [],
    hostContributions: [{
            id: 'assets.web.projects.placement-summary',
            moduleId: 'assets',
            slot: projectsProjectDetailHostSlots.sidebar,
            contractVersion: projectsProjectDetailHostCapability,
            requiredPermission: 'assets.placements.read',
            settingCondition: {
                key: 'assets.placement.display',
                property: 'projectPanelEnabled',
                equals: true,
            },
            priority: 45,
            errorBehavior: 'inline',
            emptyBehavior: 'inline',
            launcher: defineProjectsProjectDetailLauncher({
                fallbackLabel: 'Equipment',
                fallbackDescription: 'Review equipment and asset placements for this Project.',
                defaultSize: 'standard',
                supportedSizes: ['compact', 'standard', 'wide'],
            }),
            load: () => import('./assets-project-placement-summary.panel.js'),
        }],
    routes: [{
            id: 'assets.web.registry',
            moduleId: 'assets',
            path: '/assets',
            requiredPermission: 'assets.registry.read',
            navigation: {
                id: 'assets.navigation.registry',
                fallbackLabel: 'Assets',
                labelConfigurationKey: 'assets.copy.registry',
                labelValueProperty: 'navigationLabel',
                priority: 65,
            },
            load: () => import('./assets-registry.page.js'),
        }, {
            id: 'assets.web.inventory',
            moduleId: 'assets',
            path: '/assets/inventory',
            requiredPermission: 'assets.inventory.read',
            navigation: {
                id: 'assets.navigation.inventory',
                fallbackLabel: 'Inventory',
                labelConfigurationKey: 'assets.copy.inventory',
                labelValueProperty: 'navigationLabel',
                priority: 66,
            },
            load: () => import('./assets-inventory.page.js'),
        }, {
            id: 'assets.web.placements',
            moduleId: 'assets',
            path: '/assets/placements',
            requiredPermission: 'assets.placements.read',
            navigation: {
                id: 'assets.navigation.placements',
                fallbackLabel: 'Placements',
                labelConfigurationKey: 'assets.copy.placements',
                labelValueProperty: 'navigationLabel',
                priority: 67,
            },
            load: () => import('./assets-placements.page.js'),
        }, {
            id: 'assets.web.location-review',
            moduleId: 'assets',
            path: '/assets/location-review',
            requiredPermission: 'assets.location-review.read',
            navigation: {
                id: 'assets.navigation.location-review',
                fallbackLabel: 'Location review',
                labelConfigurationKey: 'assets.copy.location-review',
                labelValueProperty: 'navigationLabel',
                priority: 68,
            },
            load: () => import('./assets-location-review.page.js'),
        }],
};
export default assetsWebModuleContribution;
//# sourceMappingURL=assets-web.module-contribution.js.map